import editableData from "./siteEditable.json";

const { contactInfo } = editableData;

export const contactPageContent = {
  hero: {
    badge: "Contact TheCareerSpace",
    title: "Start with a counselling discussion tailored to your admission journey.",
    description:
      "Share your details and our team will guide the next steps with clarity for both students and parents.",
    trustNote: "Counselling conversations are practical, calm, and decision-focused."
  },
  consultationIntro:
    "Families reach out at different stages: early exploration, shortlist confusion, documentation planning, or final decision support. We are here to guide each stage in a structured way.",
  methods: [
    {
      title: "Call the Counselling Desk",
      detail: contactInfo.phoneDisplay,
      helper: contactInfo.hours,
      actionLabel: "Call Now",
      actionHref: `tel:${contactInfo.phoneHref}`
    },
    {
      title: "Write to Us",
      detail: contactInfo.email,
      helper: "Share your questions and preferred pathway.",
      actionLabel: "Send Email",
      actionHref: `mailto:${contactInfo.email}`
    },
    {
      title: "Enquiry Through Form",
      detail: "Submit your details for callback",
      helper: "Our team will connect with you shortly.",
      actionLabel: "Fill Form",
      actionHref: "#enquiry-form"
    }
  ],
  expectations: [
    "A focused discussion around student profile and goals",
    "Clear direction on suitable admission pathways",
    "Practical next-step plan for applications and decisions",
    "Parent-inclusive conversation where required"
  ],
  audienceReassurance: {
    students:
      "If you are overwhelmed by options, the discussion focuses on practical fit and manageable next steps.",
    parents:
      "If you need confidence before committing, the conversation stays transparent, comparative, and decision-focused."
  },
  reassurance:
    "No rushed advice. No pressure conversations. We prioritize clarity and responsible decision support for every family."
};

export const testimonials = [
  {
    id: 1,
    name: "Aravind Krishnamurthy",
    city: "Bengaluru",
    pathway: "Undergraduate Abroad",
    rating: 5,
    avatarColor: "from-brand-navy to-blue-700",
    quote:
      "I was completely lost about which country to pick for my bachelor's. TheCareerSpace sat with my parents and me for almost two hours on the first call — no rush, no sales pitch. They helped us build a shortlist that actually matched our budget and my interests. I'm now heading to Canada and the entire visa process was handled so smoothly."
  },
  {
    id: 2,
    name: "Divya Raghunathan",
    city: "Coimbatore",
    pathway: "Master's in India",
    rating: 5,
    avatarColor: "from-emerald-600 to-teal-700",
    quote:
      "After my engineering, I had no clarity on which MBA specialisation to choose. The counsellor asked the right questions — about my work style, family expectations, long-term goals — before suggesting anything. The shortlist was honest, not just a list of fancy names. I got into my first-choice college and I owe that clarity to them."
  },
  {
    id: 3,
    name: "Karthikeyan Subramaniam",
    city: "Chennai",
    pathway: "MBBS in India",
    rating: 5,
    avatarColor: "from-purple-600 to-indigo-700",
    quote:
      "MBBS counselling was something our family was very cautious about after hearing horror stories. TheCareerSpace was different — they never pushed us toward any specific college. Every session was calm, informative, and parent-friendly. My mother said it was the first time she actually understood the options without feeling pressured."
  },
  {
    id: 4,
    name: "Ananya Balasubramaniam",
    city: "Hyderabad",
    pathway: "Bachelor's in India",
    rating: 5,
    avatarColor: "from-rose-500 to-pink-600",
    quote:
      "Class 12 results came and I panicked because I had no backup plan. My friend referred TheCareerSpace and within three days I had a proper shortlist with realistic options. They explained each college's pros and cons without sugar-coating. The documentation guidance was step by step — nothing felt overwhelming after that."
  },
  {
    id: 5,
    name: "Siddharth Narayanan",
    city: "Kochi",
    pathway: "MBBS Abroad",
    rating: 5,
    avatarColor: "from-amber-500 to-orange-600",
    quote:
      "My family was sceptical about MBBS abroad. TheCareerSpace helped us compare countries, universities, and recognition status in a very balanced way — not favouring any one option. By the end of our second session, my parents were confident. That transformation in just two conversations was remarkable."
  },
  {
    id: 6,
    name: "Meghana Padmanabhan",
    city: "Thiruvananthapuram",
    pathway: "Undergraduate Abroad",
    rating: 5,
    avatarColor: "from-cyan-600 to-sky-700",
    quote:
      "I applied to six universities abroad and got into four. I don't think that would have happened without the structured application guidance from TheCareerSpace. They reviewed every SOP, flagged weak points, and pushed me to improve my essays. The scholarship guidance was a bonus that saved us a significant amount."
  },
  {
    id: 7,
    name: "Rohit Chandrasekaran",
    city: "Madurai",
    pathway: "Bachelor's in India",
    rating: 5,
    avatarColor: "from-violet-600 to-purple-700",
    quote:
      "I come from a small town and was intimidated by the college admission process. The counsellor at TheCareerSpace made everything feel manageable. They explained what each college actually means for career outcomes, not just rankings. I felt like I had a knowledgeable elder guiding me through the whole thing."
  },
  {
    id: 8,
    name: "Priya Venkataraman",
    city: "Vijayawada",
    pathway: "Master's in India",
    rating: 5,
    avatarColor: "from-green-600 to-emerald-700",
    quote:
      "TheCareerSpace helped me find a master's programme I genuinely wanted to pursue, not just one that looked good on paper. The intake planning was thoughtful — they factored in my work experience and helped me prepare a profile that stood out. My family feels the guidance was worth every rupee and more."
  }
];

export const enquiryFormOptions = {
  enquirerRoles: [
    "Student",
    "Parent",
    "Sibling / Guardian"
  ],
  interestAreas: [
    "General Admissions Guidance",
    "College Shortlisting",
    "Application & Documentation Support",
    "Pathway Comparison Support"
  ],
  counsellingModes: [
    "Phone Counselling",
    "Video Counselling",
    "In-Person Discussion (if available)"
  ],
  preferredStudyPaths: [
    "Bachelor's Admissions in India",
    "Master's Admissions in India",
    "MBBS in India",
    "MBBS Abroad",
    "Still Exploring"
  ]
};
